import React from 'react';
import WEBLOGO_ICON from '../../assets/images/SignLive2022.svg';
import classNames from './Policy.module.css';

const Policy = () => {
    return (
        <div
            id="Policy_1"
            className={classNames.backgroundColor}
            style={{ backgroundColor: '#161616', padding: '1px' }}
        >
            <img
                alt=""
                id="customer-dashboard-img"
                src={WEBLOGO_ICON}
                style={{ maxWidth: '100%', height: '42px', marginLeft: '30px', marginTop: '20px' }}
            />
            <div id="Policy_2" className="container-fluid" style={{ backgroundColor: 'white' }}>
                <div id="Policy_7" className="row mt-2 p-10">
                    <div id="Policy_8" className="col-3" />
                    <div id="Policy_9" className="col-7 offset-1" />
                    <div>
                        <h3>Terms &amp; Conditions</h3>
                        <p>
                            If you continue to browse and use this website you are agreeing to
                            comply with and be bound by the following terms and conditions of use,
                            which together with our privacy policy govern SignLive Ltd’s
                            relationship with you in relation to this website.
                        </p>
                        <p>
                            The term ‘SignLive Ltd’ or ‘us’ or ‘we’ refers to the owner of the
                            website whose registered office is SignLive Ltd, 152 Morrison Street,
                            Edinburgh, EH3 8EB.
                        </p>
                        <p>Our company registration number is SC243634.</p>
                        <p>
                            The term ‘you’ refers to the user or viewer of our website. The use of
                            this website is subject to the following terms of use:
                        </p>
                        <ul>
                            <li>
                                The content of the pages of this website is for your general
                                information and use only. It is subject to change without notice.
                            </li>
                            <li>
                                Neither we nor any third parties provide any warranty or guarantee
                                as to the accuracy, timeliness, performance, completeness or
                                suitability of the information and materials found or offered on
                                this website for any particular purpose.
                            </li>
                            <li>
                                You acknowledge that such information and materials may contain
                                inaccuracies or errors and we expressly exclude liability for any
                                such inaccuracies or errors to the fullest extent permitted by law.
                            </li>
                            <li>
                                Your use of any information or materials on this website is entirely
                                at your own risk, for which we shall not be liable. It shall be your
                                own responsibility to ensure that any products, services or
                                information available through this website meet your specific
                                requirements.
                            </li>
                            <li>
                                This website contains material which is owned by or licensed to us.
                                This material includes, but is not limited to, the design, layout,
                                look, appearance and graphics. Reproduction is prohibited other than
                                in accordance with the copyright notice, which forms part of these
                                terms and conditions.
                            </li>
                            <li>
                                All trademarks reproduced in this website, which are not the
                                property of, or licensed to the operator, are acknowledged on the
                                website.
                            </li>
                            <li>
                                Unauthorised use of this website may give rise to a claim for
                                damages and/or be a criminal offence.
                            </li>
                            <li>
                                From time to time this website may also include links to other
                                websites. These links are provided for your convenience to provide
                                further information. They do not signify that we endorse the
                                website(s). We have no responsibility for the content of the linked
                                website(s).
                            </li>
                            <li>
                                You may not create a link to this website from another website or
                                document without SignLive Ltd’s prior written consent.
                            </li>
                            <li>
                                You may not use the web based applications for reasons other than
                                what it has been designed for, i.e. direct calling and/or via a
                                SignLive interpreter. Any sign language interpreting carried out
                                online without written permission could result in termination of
                                accounts for both parties involved without any recompensation.
                            </li>
                            <li>
                                Your use of this website and any dispute arising out of such use of
                                the website is subject to the laws of Scotland, England and Wales.
                            </li>
                        </ul>
                        <h4>Privacy Policy</h4>
                        <p>
                            This privacy policy sets out how SignLive Ltd uses and protects any
                            information that you give SignLive Ltd when you use this website.
                            SignLive Ltd is committed to ensuring that your privacy is protected.
                            Should we ask you to provide certain information by which you can be
                            identified when using this website, then you can be assured that it will
                            only be used in accordance with this privacy statement. SignLive Ltd may
                            change this policy from time to time by updating this page. You should
                            check this page from time to time to ensure that you are happy with any
                            changes. This policy is effective from 1 May 2015.
                        </p>
                        <h4>What we collect</h4>
                        <p>We may collect the following information:</p>
                        <ul>
                            <li>name and job title</li>
                            <li>contact information including email address</li>
                            <li>
                                demographic information such as postcode, preferences and interests
                            </li>
                            <li>other information relevant to customer surveys and/or offers</li>
                        </ul>
                        <h4>What we do with the information we gather</h4>
                        <p>
                            We require this information to understand your needs and provide you
                            with a better service, and in particular for the following reasons:
                        </p>
                        <ul>
                            <li>Internal record keeping.</li>
                            <li>
                                We may use the information to improve our products and services.
                            </li>
                            <li>
                                We may periodically send promotional emails about new products,
                                special offers or other information which we think you may find
                                interesting using the email address which you have provided.
                            </li>
                            <li>
                                From time to time, we may also use your information to contact you
                                for market research purposes.
                            </li>
                        </ul>
                        <p>
                            We may contact you by email, phone, fax or mail. We may use the
                            information to customise the website according to your interests.
                        </p>
                        <h4>Security</h4>
                        <p>
                            We are committed to ensuring that your information is secure. In order
                            to prevent unauthorised access or disclosure we have put in place
                            suitable physical, electronic and managerial procedures to safeguard and
                            secure the information we collect online.
                        </p>
                        <h4>How we use cookies</h4>
                        <p>
                            A cookie is a small file which asks permission to be placed on your
                            computer’s hard drive. Once you agree, the file is added and the cookie
                            helps analyse web traffic or lets you know when you visit a particular
                            site.
                        </p>
                        <p>
                            Cookies allow web applications to respond to you as an individual. The
                            web application can tailor its operations to your needs, likes and
                            dislikes by gathering and remembering information about your
                            preferences.
                        </p>
                        <p>
                            We use traffic log cookies to identify which pages are being used. This
                            helps us analyse data about web page traffic and improve our website in
                            order to tailor it to customer needs.
                        </p>
                        <p>
                            We only use this information for statistical analysis purposes and then
                            the data is removed from the system. Overall, cookies help us provide
                            you with a better website, by enabling us to monitor which pages you
                            find useful and which you do not.
                        </p>
                        <p>
                            A cookie in no way gives us access to your computer or any information
                            about you, other than the data you choose to share with us. You can
                            choose to accept or decline cookies.
                        </p>
                        <p>
                            Most web browsers automatically accept cookies, but you can usually
                            modify your browser setting to decline cookies if you prefer. This may
                            prevent you from taking full advantage of the website.
                        </p>
                        <h4>Links to other websites</h4>
                        <p>
                            Our website may contain links to other websites of interest. However,
                            once you have used these links to leave our site, you should note that
                            we do not have any control over that other website. Therefore, we cannot
                            be responsible for the protection and privacy of any information which
                            you provide whilst visiting such sites and such sites are not governed
                            by this privacy statement.
                        </p>
                        <p>
                            You should exercise caution and look at the privacy statement applicable
                            to the website in question.
                        </p>
                        <h4>Controlling your personal information</h4>
                        <p>
                            You may choose to restrict the collection or use of your personal
                            information in the following ways:
                        </p>
                        <ul>
                            <li>
                                whenever you are asked to fill in a form on the website, look for
                                the box that you can click to indicate that you do not want the
                                information to be used by anybody for direct marketing purposes
                            </li>
                            <li>
                                if you have previously agreed to us using your personal information
                                for direct marketing purposes, you may change your mind at any time
                                by writing to or emailing us at hello_at_signlive.co.uk
                            </li>
                        </ul>
                        <p>
                            We will not sell, distribute or lease your personal information to third
                            parties unless we have your permission or are required by law to do so.
                        </p>
                        <p>
                            We may use your personal information to send you promotional information
                            about third parties which we think you may find interesting if you tell
                            us that you wish this to happen. You may request details of personal
                            information that we hold about you under the Data Protection Act 1998. A
                            small fee will be payable.
                        </p>
                        <p>
                            If you would like a copy of the information held on you please write to:
                            SignLive Ltd. Conference House 152 Morrison Street Edinburgh EH3 8EB
                        </p>
                        <p>
                            If you believe that any information we are holding on you is incorrect
                            or incomplete, please write to or email us as soon as possible, at the
                            above address. We will promptly correct any information found to be
                            incorrect.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Policy;
